function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 提供默认应用
 *
 */
import { HttpClient } from "./client";
import { BrowserXhr, HttpXhrBackend } from "./xhr";
export function isIOS() {
  return /iPhone|iPad|iPod/i.test(ua);
}
export function isAndroid() {
  return /Android/i.test(ua);
}
export function isMobile() {
  return /Mobile/i.test(ua) || isIOS() || isAndroid() || /MiuiBrowser/i.test(ua) || /BlackBerry/i.test(ua) || /Opera Mini/i.test(ua);
}
var handler = new HttpXhrBackend(new BrowserXhr());
export var defaultClient = new HttpClient(handler);
// export interface Request {
//   url: string;
//   method: string;
// }
export var MessageError = /*#__PURE__*/function (_Error) {
  _inherits(MessageError, _Error);
  var _super = _createSuper(MessageError);
  function MessageError(message, errorInfo, _ref) {
    var _this;
    var request = _ref.request,
      response = _ref.response;
    _classCallCheck(this, MessageError);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "errorInfo", void 0);
    _defineProperty(_assertThisInitialized(_this), "response", void 0);
    _defineProperty(_assertThisInitialized(_this), "request", void 0);
    _this.name = 'MessageError';
    _this.errorInfo = errorInfo;
    _this.request = request;
    _this.response = response;
    return _this;
  }
  return _createClass(MessageError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * 网络请求失败 status = 0
 */
export var NetworkError = /*#__PURE__*/function (_Error2) {
  _inherits(NetworkError, _Error2);
  var _super2 = _createSuper(NetworkError);
  function NetworkError(message, _ref2) {
    var _this2;
    var request = _ref2.request,
      response = _ref2.response;
    _classCallCheck(this, NetworkError);
    _this2 = _super2.call(this, message);
    _defineProperty(_assertThisInitialized(_this2), "response", void 0);
    _defineProperty(_assertThisInitialized(_this2), "request", void 0);
    _this2.name = 'NetworkError';
    _this2.request = request;
    _this2.response = response;
    return _this2;
  }
  return _createClass(NetworkError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * 响应错误 status > 0
 */
export var ResponseStatusError = /*#__PURE__*/function (_Error3) {
  _inherits(ResponseStatusError, _Error3);
  var _super3 = _createSuper(ResponseStatusError);
  function ResponseStatusError(message, _ref3) {
    var _this3;
    var request = _ref3.request,
      response = _ref3.response;
    _classCallCheck(this, ResponseStatusError);
    _this3 = _super3.call(this, message);
    _defineProperty(_assertThisInitialized(_this3), "status", void 0);
    _defineProperty(_assertThisInitialized(_this3), "response", void 0);
    _defineProperty(_assertThisInitialized(_this3), "request", void 0);
    _this3.name = 'ResponseStatusError';
    _this3.request = request;
    _this3.response = response;
    _this3.status = response.status;
    return _this3;
  }
  return _createClass(ResponseStatusError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function isMessageError(error) {
  // return error instanceof MessageError;
  return error instanceof Error && error.name === 'MessageError';
}
export function isNetworkError(error) {
  return error instanceof Error && error.name === 'NetworkError';
}
export function isResponseStatusError(error) {
  return error instanceof Error && error.name === 'ResponseStatusError';
}
export function resolveResponseError(request, response) {
  if (response.status === 0) {
    return new NetworkError(response.message, {
      request: request,
      response: response
    });
  } else {
    return new ResponseStatusError(response.message, {
      request: request,
      response: response
    });
  }
}
function ofObservable(observable, request) {
  return new Promise(function (resolve, reject) {
    observable.subscribe(function (response) {
      var body = response.body;
      if (body.error) {
        var errorInfo = body.error;
        var message = errorInfo.message || errorInfo.code;
        //检查异常
        reject(new MessageError(message, errorInfo, {
          response: response,
          request: request
        }));
        return;
      }
      resolve(body.data);
    }, function (response) {
      reject(resolveResponseError(request, response));
    });
  });
}
var ua = navigator.userAgent;
export function isUCBrowser() {
  return /UCBrowser/i.test(ua) || /UCWEB/i.test(ua);
}
export var Http = /*#__PURE__*/function () {
  function Http() {
    _classCallCheck(this, Http);
  }
  _createClass(Http, null, [{
    key: "get",
    value: function get(url, params, options) {
      return ofObservable(defaultClient.get(url, _objectSpread({
        params: params,
        observe: 'response'
      }, options)), {
        url: url,
        method: 'GET'
      });
    }
  }, {
    key: "post",
    value: function post(url, body, options) {
      return ofObservable(defaultClient.post(url, body, _objectSpread({
        observe: 'response'
      }, options)), {
        url: url,
        method: 'POST'
      });
    }
  }, {
    key: "patch",
    value: function patch(url, body) {
      //UC浏览器，百度浏览器都会这样   移动端暂时替换掉
      if (isMobile()) {
        //兼容部分移动端不支持PATCH body
        console.warn('mobile patch -> put request');
        return ofObservable(defaultClient.put(url, body, {
          observe: 'response',
          headers: {
            'X-Http-Method-Override': 'PATCH'
          }
        }), {
          url: url,
          method: 'PATCH'
        });
      } else {
        return ofObservable(defaultClient.patch(url, body, {
          observe: 'response'
        }), {
          url: url,
          method: 'PATCH'
        });
      }
    }
  }, {
    key: "put",
    value: function put(url, body, options) {
      return ofObservable(defaultClient.put(url, body, _objectSpread({
        observe: 'response'
      }, options)), {
        url: url,
        method: 'PUT'
      });
    }
  }, {
    key: "delete",
    value: function _delete(url, params, options) {
      return ofObservable(defaultClient.delete(url, _objectSpread({
        params: params,
        observe: 'response'
      }, options)), {
        url: url,
        method: 'DELETE'
      });
    }
  }]);
  return Http;
}();